<template>
  <div class="appContainer entrance">
    <div class="title">
      <div class="line"></div>
      <h1>{{ $t('entrance-page.header', { split: '/' }) }}</h1>
    </div>

    <v-row class="profile">
      <div class="wrapper-entry">
        <v-col cols="12" md="12" sm="12" lg="12">
          <table class="table-custom" border="0" cellspacing="0" cellpadding>
            <tbody>
              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('study_status')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('entrance-page.study-status', {
                        split: '/'
                      })
                    "
                  ></label>

                  <span class="col-require text-right" v-if="isFieldRequired('study_status')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="study_status"
                    type="text"
                    class="input input-none"
                    :value="
                      studyStatusFormat(
                        applicant_entry !== null
                          ? applicant_entry.study_status
                          : ''
                      )
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('last_academic_history')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('entrance-page.last-academic-history', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('last_academic_history')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="last_academic_history"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.last_academic_history
                        : ''
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('university_id')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('entrance-page.university', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('university_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="university_id"
                    type="text"
                    class="input input-none"
                    :value="
                      universityIdFormat(
                        applicant_entry !== null
                          ? applicant_entry.university_id
                          : ''
                      )
                    "
                    disabled
                  />
                  <div
                    v-if="
                      applicant_entry !== null &&
                      applicant_entry.school_name != null &&
                      isShowEntryInformationField('school_name')
                    "
                  >
                    <input
                      name="school_name"
                      type="text"
                      class="input input-none"
                      :value="
                        applicant_entry !== null
                          ? applicant_entry.school_name
                          : ''
                      "
                      disabled
                    />
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('faculty_id')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.faculty-id', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('faculty_id')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="faculty"
                    type="text"
                    class="input input-none"
                    :value="
                      facultyIdFormat(
                        applicant_entry !== null
                          ? applicant_entry.faculty_id
                          : ''
                      )
                    "
                    disabled
                  />
                  <div
                    v-if="
                      applicant_entry !== null &&
                      applicant_entry.faculty != null &&
                      isShowEntryInformationField('faculty')
                    "
                  >
                    <input
                      name="faculty"
                      type="text"
                      class="input input-none"
                      :value="
                        applicant_entry !== null ? applicant_entry.faculty : ''
                      "
                      disabled
                    />
                  </div>
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('graduation_month')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.graduate', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('graduation_month')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="graduation_month"
                    type="text"
                    class="input input-none"
                    :value="
                      formatMonth(
                        applicant_entry !== null
                          ? applicant_entry.graduation_month
                          : ''
                      )
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.work-status', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('work_status')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                  <!-- <span
                      class="col-require text-right"
                      v-if="isShowEntryInformationField('work_status_text')"
                    >
                      {{
                        $t('profile-page.status.required', {
                          split: '/'
                        })
                      }}
                    </span> -->
                </td>
                <td class="td-right">
                  <input
                    name="work_status"
                    type="text"
                    class="input input-none"
                    :value="
                      workStatusFormat(
                        applicant_entry !== null
                          ? applicant_entry.work_status
                          : ''
                      )
                    "
                    disabled
                    v-if="isShowEntryInformationField('work_status')"
                  />
                  <input
                    name="work_status_text"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.work_status_text
                        : ''
                    "
                    disabled
                    v-if="isShowEntryInformationField('work_status_text')"
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus && isShowEntryInformationField('company_name')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.company-name', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('company_name')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="company_name"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.company_name
                        : ''
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus &&
                  isShowEntryInformationField('industry_type')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.industry-type', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('industry_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="industry_type"
                    type="text"
                    class="input input-none"
                    :value="
                      industryTypeFormat(
                        applicant_entry !== null
                          ? applicant_entry.industry_type
                          : ''
                      )
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus &&
                  isShowEntryInformationField('occupation_type')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.position', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('occupation_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="occupation_type"
                    type="text"
                    class="input input-none"
                    :value="occupationTypeFormat()"
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkWorkStatus &&
                  isShowEntryInformationField('work_contract_type')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.work-contract-type', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('work_contract_type')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="work_contract_type"
                    type="text"
                    class="input input-none"
                    :value="
                      workContractFormat(
                        applicant_entry !== null
                          ? applicant_entry.work_contract_type
                          : ''
                      )
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="
                  checkRetireWorkStatus &&
                  isShowEntryInformationField('resignation_month')
                "
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.resignation-month', {
                        split: '/'
                      })
                    "
                  ></label>
                </td>
                <td class="td-right">
                  <input
                    name="work_status"
                    type="text"
                    class="input input-none"
                    :value="
                      formatDate(
                        applicant_entry !== null
                          ? applicant_entry.resignation_month
                          : ''
                      )
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('jlpt_level')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.japanese-level', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('jlpt_level')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="name"
                    type="text"
                    class="input input-none"
                    :value="
                      japanLevelFormat(
                        applicant_entry !== null
                          ? applicant_entry.jlpt_level
                          : ''
                      )
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('english_level')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.english-level', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('english_level')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="name"
                    type="text"
                    class="input input-none"
                    :value="englishLevelFormat()"
                    disabled
                  />
                </td>
              </tr>

              <!-- </v-col>
              <v-col cols="12" md="12" sm="12" lg="12"> -->
              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('toeic_score')"
              >
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.toeic-score', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('toeic_score')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="toeic_score"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.toeic_score
                        : ''
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.skill', {
                        split: '/'
                      })
                    "
                    v-if="isShowEntryInformationField('skill_type')"
                  ></label>

                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.skill-text', {
                        split: '/'
                      })
                    "
                    v-if="isShowEntryInformationField('skill_name_text')"
                  ></label>

                  <span
                    class="col-require text-right"
                    v-if="isShowEntryInformationField('skill_name_text') || isFieldRequired('skill_type')"
                  >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>

                <td class="td-right">
                  <div
                    class="skill-box"
                    v-if="isShowEntryInformationField('skill_type')"
                  >
                    <div
                      class="widget-skill"
                      style="padding-left: 15px"
                      v-for="(item, index) in skillTypeFormat()"
                      :key="index"
                    >
                      {{ item.name_convert }}
                    </div>
                  </div>
                  <input
                    name="skill_name_text"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.skill_name_text
                        : ''
                    "
                    disabled
                    v-if="isShowEntryInformationField('skill_name_text')"
                  />
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.desired-job', {
                        split: '/'
                      })
                    "
                  ></label>

                  <span
                    class="col-require text-right"
                    v-if="isFieldRequired('expect_occupation_type')"
                  >
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <div
                    class="skill-box"
                    v-if="isShowEntryInformationField('expect_occupation_type')"
                  >
                    <div
                      class="widget-skill"
                      style="padding-left: 15px"
                      v-for="(item, index) in expectOccupationTypeFormat()"
                      :key="index"
                    >
                      {{ item.name_convert }}
                    </div>
                  </div>
                  <input
                    name="expect_occupation_type_text"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.expect_occupation_type_text
                        : ''
                    "
                    disabled
                    v-if="
                      isShowEntryInformationField('expect_occupation_type_text')
                    "
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('expected_requirements')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('entrance-page.expected-requirements', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('expected_requirements')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="expected_requirements"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.expected_requirements
                        : ''
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('expected_pay')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('entrance-page.expected-pay', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('expected_pay')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="expected_pay"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.expected_pay
                        : ''
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr
                class="tr-response"
                v-if="isShowEntryInformationField('any_additional_comments')"
              >
                <td class="td-left">
                  <label
                    style=""
                    for="name"
                    v-html="
                      $t('entrance-page.any-additional-comments', {
                        split: '/'
                      })
                    "
                  ></label>
                </td>
                <td class="td-right">
                  <input
                    name="any_additional_comments"
                    type="text"
                    class="input input-none"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.any_additional_comments
                        : ''
                    "
                    disabled
                  />
                </td>
              </tr>

              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.work-locate', {
                        split: '/'
                      })
                    "
                  ></label>
                  <span class="col-require text-right" v-if="isFieldRequired('work_location')">
                    {{
                      $t('profile-page.status.required', {
                        split: '/'
                      })
                    }}
                  </span>
                </td>
                <td class="td-right">
                  <input
                    name="work_location"
                    type="text"
                    class="input input-none"
                    :value="workLocationFormat()"
                    disabled
                    v-if="isShowEntryInformationField('work_location')"
                  />
                </td>
              </tr>
              <tr class="tr-response">
                <td class="td-left">
                  <label
                    for="name"
                    v-html="
                      $t('entrance-page.self_promotion', {
                        split: '/'
                      })
                    "
                  ></label>
                </td>
                <td class="td-right">
                  <textarea
                    name="self_promotion"
                    type="text"
                    class="input input-none"
                    rows="5"
                    :value="
                      applicant_entry !== null
                        ? applicant_entry.self_promotion
                        : ''
                    "
                    disabled
                  ></textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </div>
    </v-row>

    <div class="text-center">
      <v-btn class="btn-update" depressed color="#E8320D" @click="updateEvent"
        >{{ $t('component.button-edit', { split: '/' }) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import './entrance.scss';
import { masterMixin } from '@/mixins/masterMixin.js';
import {
  LANG_CODE_JAPANESE,
  OTHER_SELECT_TEXT_VN,
  OTHER_SELECT_TEXT_JP,
  WORK_STATUS_YES,
  EVENT_DEFAULT
} from '@/common/constants';

export default {
  mixins: [masterMixin],
  data() {
    return {
      EVENT_DEFAULT,
      skill_type: [],
      occupation_type: [],
      expect_occupation_type: [],
      checkRetireWorkStatus: false
    };
  },

  watch: {
    applicant_entry: function (val) {
      const {
        study_status,
        university_id,
        school_name,
        faculty_id,
        faculty,
        graduation_month,
        work_status,
        company_name,
        industry_type,
        occupation_type,
        work_contract_type,
        resignation_month,
        jlpt_level,
        english_level,
        work_location,
        toeic_score,
        expect_occupation_type,
        skill_type,
        self_promotion
      } = val;

      return [
        (this.study_status = study_status),
        (this.university_id = university_id),
        (this.school_name = school_name),
        (this.faculty_id = faculty_id),
        (this.faculty = faculty),
        (this.graduation_month = graduation_month),
        (this.work_status = work_status), // step-2
        (this.company_name = company_name),
        (this.industry_type = industry_type),
        // (this.occupation_type = occupation_type), // KhoaVN commented 2023_10_17
        (this.work_contract_type = work_contract_type),
        (this.resignation_month = resignation_month),
        (this.jlpt_level = jlpt_level),
        (this.english_level = english_level),
        (this.toeic_score = toeic_score),
        (this.work_location = work_location),
        (this.self_promotion = self_promotion),
        (this.expect_occupation_type =
          expect_occupation_type !== null
            ? JSON.parse(expect_occupation_type)
            : []),
        // (this.occupation_type =
        //   expect_occupation_type !== null
        //     ? JSON.parse(expect_occupation_type)
        //     : []), // KhoaVN commented 2023_10_17
        (this.occupation_type =
          occupation_type !== null ? JSON.parse(occupation_type) : []), // KhoaVN added 2023_10_17
        (this.skill_type = skill_type !== null ? JSON.parse(skill_type) : [])
      ];
    },

    work_status: function (val) {
      if (val == WORK_STATUS_YES) {
        this.checkRetireWorkStatus = true;
        this.checkWorkStatusToDisplay = true;
      } else {
        this.checkWorkStatusToDisplay = false;
      }
    }
  },

  mounted() {
    if (this.applicant_entry !== null) {
      const {
        study_status,
        university_id,
        school_name,
        faculty_id,
        faculty,
        graduation_month,
        work_status,
        company_name,
        industry_type,
        occupation_type,
        work_contract_type,
        resignation_month,
        jlpt_level,
        english_level,
        work_location,
        toeic_score,
        expect_occupation_type,
        skill_type,
        self_promotion
      } = this.applicant_entry;

      return [
        (this.study_status = study_status),
        (this.university_id = university_id == null ? '' : university_id),
        (this.school_name = school_name),
        (this.faculty_id = faculty_id),
        (this.faculty = faculty),
        (this.graduation_month = graduation_month),
        (this.work_status = work_status), // step-2
        (this.company_name = company_name),
        (this.industry_type = industry_type),
        // (this.occupation_type = occupation_type), // KhoaVN commented 2023_10_17
        (this.work_contract_type = work_contract_type),
        (this.resignation_month = resignation_month),
        (this.jlpt_level = jlpt_level),
        (this.english_level = english_level),
        (this.toeic_score = toeic_score),
        (this.work_location = work_location),
        (this.self_promotion = self_promotion),
        (this.expect_occupation_type =
          expect_occupation_type !== null
            ? JSON.parse(expect_occupation_type)
            : []),
        // (this.occupation_type =
        //   expect_occupation_type !== null
        //     ? JSON.parse(expect_occupation_type)
        //     : []), // KhoaVN commented 2023_10_17
        (this.occupation_type =
          occupation_type !== null ? JSON.parse(occupation_type) : []), // KhoaVN added 2023_10_17
        (this.skill_type = skill_type !== null ? JSON.parse(skill_type) : [])
      ];
    }
  },

  computed: {
    ...mapGetters({
      applicant_entry: 'getEntryInfomation',
      m_template: 'getMTemplate',
      m_event: 'getMEvent',
    }),
    checkWorkStatus() {
      return this.work_status === WORK_STATUS_YES;
    }
  },

  methods: {
    updateEvent() {
      this.$emit('updateEvent');
    },

    studyStatusFormat: function () {
      const arr = this.c_study_status.filter(
        (ele) => ele.id === this.study_status
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    occupationTypeFormat: function () {
      const arr = this.m_occupation_type_no_group.filter(
        (ele) => ele.id === this.occupation_type[0]
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    expectOccupationTypeFormat: function () {
      const arr = this.m_occupation_type_no_group.filter((ele) => {
        if (this.expect_occupation_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    skillTypeFormat: function () {
      const arr = this.m_skill.filter((ele) => {
        if (this.skill_type.includes(ele.id)) {
          return true;
        }
      });

      return arr;
    },

    workStatusFormat: function () {
      const arr = this.c_work_status.filter(
        (ele) => ele.id === this.work_status
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    universityIdFormat: function () {
      if (this.university_id == '0' || this.university_id === null) {
        return this.$i18n.locale == LANG_CODE_JAPANESE
          ? OTHER_SELECT_TEXT_JP
          : OTHER_SELECT_TEXT_VN;
      } else {
        const arr = this.m_university.filter(
          (ele) => ele.id === this.university_id
        );
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },

    facultyIdFormat: function () {
      if (this.faculty_id == '0' || this.faculty_id === null) {
        return this.$i18n.locale == LANG_CODE_JAPANESE
          ? OTHER_SELECT_TEXT_JP
          : OTHER_SELECT_TEXT_VN;
      } else {
        const arr = this.m_faculty.filter((ele) => ele.id === this.faculty_id);
        if (arr.length > 0) {
          return arr[0].name_convert;
        } else return null;
      }
    },

    isFieldRequired(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('required')) {
        return modification.required;
      }
      // Default required fields for display based on template type
      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        const defaultRequired = [
          'study_status', 'university_id', 'faculty_id', 'graduation_month',
          'work_status', 'jlpt_level', 'english_level', 'expect_occupation_type',
          'work_location'
        ];
        if (this.work_status === WORK_STATUS_YES) {
          defaultRequired.push('company_name', 'industry_type', 'occupation_type', 'work_contract_type');
        }
        return defaultRequired.includes(fieldName);
      } else {
        const defaultRequired = [
          'last_academic_history', 'work_status_text', 'skill_name_text',
          'expect_occupation_type_text', 'expected_requirements', 'expected_pay',
          'work_location'
        ];
        return defaultRequired.includes(fieldName);
      }
    },

    workContractFormat: function () {
      const arr = this.c_work_contract_type.filter(
        (ele) => ele.id === this.work_contract_type
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    japanLevelFormat: function () {
      const arr = this.c_japanese_level.filter(
        (ele) => ele.id == this.jlpt_level
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    englishLevelFormat: function () {
      const arr = this.c_english_level.filter(
        (ele) => ele.id == this.english_level
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    workLocationFormat: function () {
      const arr = this.m_work_location_applicant.filter(
        (ele) => ele.id === this.work_location
      );
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    }
  }
};
</script>

<style></style>
